import React, { memo, useState } from 'react';
import { Icon } from '@web/utils';
import { Account, ProfileImg, ProfileImgPlaceholder, SignIn, SignOut, StyledUserBox } from './Header.Styles';
import { userRoles } from '../../../ModuleApp';
import { useAuth, Auth } from '../../../ModuleAuth';
import { useAccount } from '../../../ModuleAccount';
export var UserBox = memo(function (_a) {
    var _b;
    var signOutRoute = _a.signOutRoute, accountRoute = _a.accountRoute;
    var auth = useAuth().auth;
    var account = useAccount().account;
    var _c = useState(false), showAuth = _c[0], setShowAuth = _c[1];
    var toggleShowAuth = function () { return setShowAuth(function (prevState) { return !prevState; }); };
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledUserBox, null, auth.user
            ? React.createElement(React.Fragment, null,
                React.createElement(Account, { to: accountRoute },
                    auth.user && auth.user.photoURL
                        ? React.createElement(ProfileImg, { src: auth.user.photoURL, alt: "Profile" })
                        : React.createElement(ProfileImgPlaceholder, null),
                    React.createElement("div", null, (_b = auth.user.displayName) === null || _b === void 0 ? void 0 :
                        _b.split(' ')[0],
                        React.createElement("small", null, userRoles.list[account.role].title))),
                React.createElement(SignOut, { to: signOutRoute },
                    React.createElement(Icon, { icon: "power-off" })))
            : React.createElement(SignIn, { onClick: toggleShowAuth }, "P\u0159ihl\u00E1sit")),
        showAuth &&
            React.createElement(Auth, { onClose: toggleShowAuth, key: "auth" })));
});
